module.exports = __webpack_public_path__ + "img/upload_image.e59a6e35.svg";